import { render } from "./AsignarProfesionalModal.vue?vue&type=template&id=38589b63&ts=true"
import script from "./AsignarProfesionalModal.vue?vue&type=script&lang=ts"
export * from "./AsignarProfesionalModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__